// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"55":"d1367e25","161":"a4cd8664","408":"b79056d5","563":"947e28e6","819":"bcbd6a5d"}[chunkId] + ".js";
};